import Logger from './core/logger'

export {
  Logger
}

export default Logger



// WEBPACK FOOTER //
// ./src/index.js